import React, { Component, Fragment } from 'react'
import { Button, CircleLoader } from '@drifthq/tide-core'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import queryString from 'query-string'

import * as OrgActions from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'
import * as RoutingSelectors from 'modules/routing/selectors'

import config from 'config'
import Google_Logo from './google-logo.svg'

class GoogleAuth extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }

  componentDidMount() {
    if (this.props.search && this.props.pathname.includes("google")) {
      this.onLoading()
      this.onHideError()
      const token = queryString.parse(this.props.search).code
      this.props.onProcessingExternalGoogleCode(token)
    }
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.oauthError !== this.props.oauthError) && (this.props.oauthError !== false)) {
      this.setState({ loading: false })
    }
  }

  redirectToGoogleLogin() {
    const redirectUriPath = window.location.pathname.includes('/video')
      ? '/letsgo/video/select/google'
      : '/letsgo/start/select/google'

    const params = {
      response_type: 'code',
      redirect_uri: `${config.LETS_GO_URL}${redirectUriPath}`,
      client_id: config.GOOGLE_CLIENT_ID,
      scope: `https://www.googleapis.com/auth/calendar openid email`,
      access_type: 'offline',
      include_granted_scopes: true,
    }
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${queryString.stringify(params)}`
  }

  onHideError = () => {
    this.props.actions.setOAuthError(false)
  }

  onLoading = () => {
    this.setState({ loading: true })
  }

  render() {
    const { loading } = this.state
    
    return (
      <Fragment>
        <div className="touchless-start-oauth-login-container" id="google">
          <Button className="touchless-start-oauth-login-button" onClick={() => !loading && this.redirectToGoogleLogin()} type="tertiary">
            <div className="touchless-start-oauth-login-logo">
              <img alt="" src={Google_Logo} height="20" width="20" />
            </div>
            <div className="touchless-start-oauth-login-text">
              {loading ? (
                <CircleLoader size="small" />
              ) : (
                'Sign up with Google'
              )}
            </div>
          </Button>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  pathname: RoutingSelectors.getPathname(state),
  search: RoutingSelectors.getSearch(state),
  oauthError: OrgSelectors.getOAuthError(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setOAuthError: OrgActions.setOAuthError
  }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(GoogleAuth)



// WEBPACK FOOTER //
// ./src/layouts/SignupChoiceCard/GoogleAuth.js